import { BLOCKED_EMBED_TYPES } from './constants';

/**
 * Checks if a Delta op is a blocked embed type.
 * Returns true if op.insert is an object containing any key from BLOCKED_EMBED_TYPES.
 *
 * @param op - A Quill Delta operation
 * @returns true if the op is a blocked embed, false otherwise
 */
export function isBlockedEmbed(op: unknown): boolean {
  if (!op || typeof op !== 'object') {
    return false;
  }

  const operation = op as Record<string, unknown>;
  const { insert } = operation;

  if (!insert || typeof insert !== 'object') {
    return false;
  }

  const insertObj = insert as Record<string, unknown>;

  return BLOCKED_EMBED_TYPES.some((type) => type in insertObj);
}
